import cn from 'classnames';
import { useMemo } from 'react';

import { capitalizeFirstLetter } from '@app/shared/utils';

import type { Moment } from 'moment';
import type { FC } from 'react';

import '../styles/DaysHeadersStrip.scss';

export interface DaysHeadersStripProps {
  days: Moment[];
  todayMoment: Moment;
  executorNonWorkingDates: string[];
}

export const DaysHeadersStrip: FC<DaysHeadersStripProps> = (props) => {
  const { days, todayMoment, executorNonWorkingDates } = props;
  const executorNonWorkingDateSet = useMemo(
    () => new Set(executorNonWorkingDates),
    [executorNonWorkingDates]
  );

  return (
    <div className="DaysHeadersStrip" data-testid="days-headers-strip">
      <div
        className="DaysHeadersStrip__track"
        style={{
          gridTemplateColumns: `repeat(${days.length}, minmax(0, 1fr))`,
        }}
      >
        {days.map((dayMoment) => {
          const dayKey = dayMoment.format('YYYY-MM-DD');
          const isExecutorNonWorkingDay = executorNonWorkingDateSet.has(dayKey);
          const weekdayLabel = capitalizeFirstLetter(
            dayMoment.clone().locale('ru').format('dddd')
          );
          const dateLabel = dayMoment
            .clone()
            .locale('ru')
            .format(
              dayMoment.year() === todayMoment.year() ? 'D MMMM' : 'D MMMM YYYY'
            );

          return (
            <div
              key={dayKey}
              className={cn('DaysHeadersStrip__cell', {
                'DaysHeadersStrip__cell--non-working-day':
                  isExecutorNonWorkingDay,
              })}
              data-testid={`day-header-${dayKey}`}
            >
              <span className="DaysHeadersStrip__weekday">{weekdayLabel}</span>
              <span className="DaysHeadersStrip__date">{dateLabel}</span>
              {isExecutorNonWorkingDay && (
                <span
                  className="DaysHeadersStrip__non-working-indicator"
                  data-testid={`day-header-non-working-indicator-${dayKey}`}
                >
                  Нерабочий день
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
